import VueQr3 from './vue3-qr-code-styling.vue'

export default VueQr3
